module.exports = __webpack_public_path__ + "img/dashboard-pay-auth.5291062b.svg";